import styled from '../../../styles/theme';
import OfferListItemTemplate from './OfferListTemplate';
import { rem } from 'polished';

export const OffersListStyled = styled(OfferListItemTemplate)``;
